import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

export default function SEO({ title, description, image, keywords }) {
  const location = useLocation();
  useEffect(() => {
    applyMeta(title, description, image, keywords);
    api.get(`/public/seo?path=${encodeURIComponent(location.pathname)}`)
      .then((r) => {
        const d = r.data || {};
        if (d.title || d.description || d.keywords || d.image) {
          applyMeta(d.title || title, d.description || description, d.image || image, d.keywords || keywords);
        }
      })
      .catch(() => {});
  }, [title, description, image, keywords, location.pathname]);
  return null;
}

function applyMeta(title, description, image, keywords) {
  const base = "Sahaj Sarathi Foundation";
  document.title = title ? `${title} | ${base}` : `${base} | Registered NGO, Uttar Pradesh`;
  setMeta("description", description || "Sahaj Sarathi Foundation is a registered NGO working on education, health awareness, social security, disability inclusion and skill development.");
  if (keywords) setMeta("keywords", keywords);
  setProp("og:title", document.title);
  setProp("og:description", description || "");
  if (image) { setProp("og:image", absolutize(image)); setMeta("twitter:image", absolutize(image)); }
}

function absolutize(url) {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  return `${window.location.origin}${url}`;
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
  el.setAttribute("content", content || "");
}

function setProp(prop, content) {
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute("property", prop); document.head.appendChild(el); }
  el.setAttribute("content", content || "");
}
